<script setup>
import IconCheck from '@/Svgs/Check.svg.vue';

import {computed} from "vue";

const props = defineProps({
    modelValue: {
        type: [Boolean, Array],
        required: true,
    },
    label: {
        type: [String, Number],
        required: true
    },
    required: {
        type: Boolean,
        default: true
    },
    icon: {
        type: Object,
        default: null,
    },
    trueValue: {
        type: [String, Number, Boolean],
        default: true
    },
    falseValue: {
        type: [String, Number, Boolean],
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

const isChecked = computed(() => {
    if (Array.isArray(props.modelValue)) {
        return props.modelValue.includes(props.trueValue);
    }
    return props.modelValue === props.trueValue;
});

const updateModelValue = () => {
    if (Array.isArray(props.modelValue)) {
        const newValue = isChecked.value ? props.modelValue.filter(v => v !== props.trueValue) : [...props.modelValue, props.trueValue];
        emit('update:modelValue', newValue);
    } else {
        const newValue = isChecked.value ? props.falseValue : props.trueValue;
        emit('update:modelValue', newValue);
    }
}
</script>

<template>
    <div :class="['checkboxLabel -is-clickable', {'-has-no-label': label === ''}]">
        <label>
            <input
                type="checkbox"
                :required="required"
                :checked="isChecked"
                :disabled="disabled"
                :true-value="trueValue"
                :false-value="falseValue"
                @change="updateModelValue"
            />
            <span :class="['checkboxLabel-marker', {'-is-disabled': disabled}]">
                <IconCheck v-if="isChecked" />
            </span>
            <component
                v-if="icon"
                :is="icon"
                class="checkboxLabel-icon"
            />
            <span
                v-if="label"
                :class="['checkboxLabel-text', {'-has-icon': icon}]"
                v-html="label"
            />
            <slot></slot>
        </label>
    </div>
</template>

<style lang="scss" scoped>
@use '~@/base/variables' as *;

.checkboxLabel {
    position: relative;

    &.-has-no-label {
        width: 26px;
    }
    label {
        display: flex;
        align-items: center;
        gap: 16px;
        cursor: pointer;
        flex-wrap: wrap;
        color: $blue800;
        font-weight: 500;
    }
    input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
    &-marker {
        border-radius: 4px;
        border: 1px solid black;
        background-color: white;
        flex: 0 0 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.-is-disabled {
            opacity: 0.5;
        }
    }
    &-text {
        margin-top: 2px;
        flex: 1;

        &.-has-icon {
            margin-left: -9px;
        }
    }
}

</style>
